import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import assetsPath from '../../constant.js';
import { GenericIconEnum, GenericIconSize } from './nn-generic-icon.enum';

/**
 * Generic Icon
 *
 * iconName - The icon to display.
 * ariaLabel - The text for the label.
 * size - The size of the icon. (ie: small, medium, large)
 */
@customElement('nn-generic-icon')
export class GenericIcon extends LitElement {
  static styles = css`
    .nn-generic-icon {
      align-items: center;
      display: inline-flex;
      justify-content: flex-end;
    }

    .nn-generic-icon--small {
      height: 16px;
      width: 16px;
    }

    .nn-generic-icon--medium {
      height: 32px;
      width: 32px;
    }

    .nn-generic-icon--large {
      height: 64px;
      width: 64px;
    }
  `;

  @property({ type: String }) iconName = GenericIconEnum.PACKAGE_OPEN;

  @property({ type: String }) ariaLabel = 'Icône';

  @property({ type: String }) size = GenericIconSize.INHERIT;

  render() {
    return html`
      <div class="nn-generic-icon">
        <img
          class="nn-generic-icon--${this.size}"
          src="${assetsPath}/icons/${this.iconName}.svg"
          alt="${this.ariaLabel}"
          aria-label="${this.ariaLabel}"
          aria-hidden="true"
          loading="lazy"
        />
      </div>
    `;
  }
}
